import $P from 'plugins/kapida/platformConfigs/integrationMaps/packageOrderDetail';
import { objectSelector } from 'theme/utils';

export class PackageOrder {
  constructor(item) {
    const {
      channelName,
      commands,
      id,
      number,
      orderId,
      orderNumber,
      orderNotes,
      packageItemSet,
      shipment,
      shipmentCargoName,
      shipmentAwbNumber,
      shippingAddress,
      shippingLabel,
      shippingPreviewUrl,
      state,
      stockLocation,
      giftBoxNote,
      deliveryRange,
      isClickAndCollect,
      billingAddress,
    } = item;
    this.channelName = channelName;
    this.commands = commands;
    this.id = id;
    this.number = number;
    this.orderId = orderId;
    this.orderNumber = orderNumber;
    this.orderNotes = orderNotes;
    this.packageItemSet = packageItemSet;
    this.shipment = shipment;
    this.shipmentCargoName = shipmentCargoName;
    this.shipmentAwbNumber = shipmentAwbNumber;
    this.shippingAddress = shippingAddress;
    this.shippingLabel = shippingLabel;
    this.shippingPreviewUrl = shippingPreviewUrl;
    this.state = state;
    this.stockLocation = stockLocation;
    this.giftBoxNote = giftBoxNote;
    this.deliveryRange = deliveryRange;
    this.isClickAndCollect = isClickAndCollect;
    this.billingAddress = billingAddress;
  }
}

export class PackageItem {
  constructor(item) {
    const {
      id,
      orderItem,
      state,
      transferDestination,
      transferTargetDate,
      unit_weight,
    } = item;
    this.id = id;
    this.orderItem = orderItem;
    this.state = state;
    this.transferDestination = transferDestination;
    this.transferTargetDate = transferTargetDate;
    this.unit_weight = unit_weight;
  }
}

class OrderItem {
  constructor(item) {
    const {
      id,
      product,
      giftNote,
      innerFrameNote,
      innerFrameColor,
      outerFrameColor,
      miscImageOriginal,
      miscImage,
      miscImageInfo,
      attributes,
      attributesKwargs,
      price,
      retailPrice,
      currency,
      discountAmount,
    } = item;
    this.id = id;
    this.product = product;
    this.giftNote = giftNote;
    this.innerFrameNote = innerFrameNote;
    this.innerFrameColor = innerFrameColor;
    this.outerFrameColor = outerFrameColor;
    this.miscImageOriginal = miscImageOriginal;
    this.miscImage = miscImage;
    this.miscImageInfo = miscImageInfo;
    this.attributes = attributes;
    this.attributesKwargs = attributesKwargs;
    this.price = price;
    this.retailPrice = retailPrice;
    this.currency = currency;
    this.discountAmount = discountAmount;
  }
}

class Product {
  constructor(item) {
    const {
      id,
      image,
      name,
      baseName,
      sku,
      color,
      size,
      dimensions,
      codeToScan,
      attributes,
      attributes_kwargs,
    } = item;
    this.id = id;
    this.image = image;
    this.name = name;
    this.baseName = baseName;
    this.sku = sku;
    this.color = color;
    this.size = size;
    this.dimensions = dimensions;
    this.codeToScan = codeToScan;
    this.attributes = attributes;
    this.attributes_kwargs = attributes_kwargs;
  }
}

class MiscImage {
  constructor(item) {
    const { rotate, scale, translateX, translateY } = item;
    this.rotate = rotate;
    this.scale = scale;
    this.translateX = translateX;
    this.translateY = translateY;
  }
}

class ShippingAddress {
  constructor(item) {
    const {
      customerName,
      customerSurname,
      customerEmail,
      phone,
      title,
      line,
      city,
      township,
      district,
    } = item;
    this.customerName = customerName;
    this.customerSurname = customerSurname;
    this.customerEmail = customerEmail;
    this.phone = phone;
    this.title = title;
    this.line = line;
    this.city = city;
    this.township = township;
    this.district = district;
  }
}

// eslint-disable-next-line no-unused-vars
class BillingAddress {
  constructor(item) {
    const {
      customerName,
      customerSurname,
      customerEmail,
      phone,
      title,
      line,
      city,
      township,
      district,
    } = item;
    this.customerName = customerName;
    this.customerSurname = customerSurname;
    this.customerEmail = customerEmail;
    this.phone = phone;
    this.title = title;
    this.line = line;
    this.city = city;
    this.township = township;
    this.district = district;
  }
}

class StockLocation {
  constructor(item) {
    const { name, addressTitle, addressLine, addressCity } = item;
    this.name = name;
    this.addressTitle = addressTitle;
    this.addressLine = addressLine;
    this.addressCity = addressCity;
  }
}

class DeliveryRange {
  constructor({ lower, upper }) {
    this.lower = lower;
    this.upper = upper;
  }
}

const shippingAddressMapper = (item) => {
  return new ShippingAddress({
    customerName: objectSelector(item, $P.SHIPPING_ADDRESS.CUSTOMER_NAME),
    customerSurname: objectSelector(item, $P.SHIPPING_ADDRESS.CUSTOMER_SURNAME),
    customerEmail: objectSelector(item, $P.SHIPPING_ADDRESS.CUSTOMER_EMAIL),
    phone: objectSelector(item, $P.SHIPPING_ADDRESS.PHONE),
    title: objectSelector(item, $P.SHIPPING_ADDRESS.TITLE),
    line: objectSelector(item, $P.SHIPPING_ADDRESS.LINE),
    city: objectSelector(item, $P.SHIPPING_ADDRESS.CITY),
    district: objectSelector(item, $P.SHIPPING_ADDRESS.DISTRICT),
    township: objectSelector(item, $P.SHIPPING_ADDRESS.TOWNSHIP),
  });
};

const billingAddressMapper = (item) => {
  return new ShippingAddress({
    customerName: objectSelector(item, $P.BILLING_ADDRESS.CUSTOMER_NAME),
    customerSurname: objectSelector(item, $P.BILLING_ADDRESS.CUSTOMER_SURNAME),
    customerEmail: objectSelector(item, $P.BILLING_ADDRESS.CUSTOMER_EMAIL),
    phone: objectSelector(item, $P.BILLING_ADDRESS.PHONE),
    title: objectSelector(item, $P.BILLING_ADDRESS.TITLE),
    line: objectSelector(item, $P.BILLING_ADDRESS.LINE),
    city: objectSelector(item, $P.BILLING_ADDRESS.CITY),
    district: objectSelector(item, $P.BILLING_ADDRESS.DISTRICT),
    township: objectSelector(item, $P.BILLING_ADDRESS.TOWNSHIP),
  });
};

const stockLocationMapper = (item) => {
  return new StockLocation({
    name: objectSelector(item, $P.STOCK_LOCATION.NAME),
    addressTitle: objectSelector(item, $P.STOCK_LOCATION.ADDRESS_TITLE),
    addressLine: objectSelector(item, $P.STOCK_LOCATION.ADDRESS_LINE),
    addressCity: objectSelector(item, $P.STOCK_LOCATION.ADDRESS_CITY),
  });
};

const deliveryRangeMapper = (item) => {
  return new DeliveryRange({
    lower: objectSelector(item, $P.DELIVERY_RANGE.LOWER),
    upper: objectSelector(item, $P.DELIVERY_RANGE.UPPER),
  });
};

const productMapper = (item) => {
  const { PRODUCT } = $P.PACKAGE_ITEM.ORDER_ITEM;
  return new Product({
    id: objectSelector(item, PRODUCT.ID),
    image: objectSelector(item, PRODUCT.IMAGE),
    name: objectSelector(item, PRODUCT.NAME),
    baseName: objectSelector(item, PRODUCT.BASE_NAME),
    sku: objectSelector(item, PRODUCT.SKU),
    color: objectSelector(item, PRODUCT.COLOR),
    size: objectSelector(item, PRODUCT.SIZE),
    dimensions: objectSelector(item, PRODUCT.DIMENSIONS),
    codeToScan: objectSelector(item, PRODUCT.CODE_TO_SCAN),
    attributes: objectSelector(item, PRODUCT.ATTRIBUTES),
    attributes_kwargs: objectSelector(item, PRODUCT.ATTRIBUTES_KWARGS),
  });
};

const miscImageInfoMapper = (item) => {
  const { MISC_IMAGE_INFO } = $P.PACKAGE_ITEM.ORDER_ITEM;
  return new MiscImage({
    rotate: objectSelector(item, MISC_IMAGE_INFO.ROTATE),
    scale: objectSelector(item, MISC_IMAGE_INFO.SCALE),
    translateX: objectSelector(item, MISC_IMAGE_INFO.TRANSLATE_X),
    translateY: objectSelector(item, MISC_IMAGE_INFO.TRANSLATE_Y),
  });
};

const orderItemMapper = (item) => {
  const { ORDER_ITEM } = $P.PACKAGE_ITEM;
  return new OrderItem({
    id: objectSelector(item, ORDER_ITEM.ID),
    product: productMapper(objectSelector(item, ORDER_ITEM.PRODUCT_PATH)),
    giftNote: objectSelector(item, ORDER_ITEM.GIFT_NOTE),
    discountAmount: objectSelector(item, ORDER_ITEM.DISCOUNT_AMOUNT),
    innerFrameNote: objectSelector(item, ORDER_ITEM.INNER_FRAME_NOTE),
    innerFrameColor: objectSelector(item, ORDER_ITEM.INNER_FRAME_COLOR),
    outerFrameColor: objectSelector(item, ORDER_ITEM.OUTER_FRAME_COLOR),
    miscImageOriginal: objectSelector(item, ORDER_ITEM.MISC_IMAGE_ORIGINAL),
    miscImage: objectSelector(item, ORDER_ITEM.MISC_IMAGE),
    miscImageInfo: miscImageInfoMapper(
      objectSelector(item, ORDER_ITEM.MISC_IMAGE_INFO_PATH)
    ),
    attributes: objectSelector(item, ORDER_ITEM.ATTRIBUTES),
    attributesKwargs: objectSelector(item, ORDER_ITEM.ATTRIBUTES_KWARGS),
    price: objectSelector(item, ORDER_ITEM.PRICE),
    retailPrice: objectSelector(item, ORDER_ITEM.RETAIL_PRICE),
    currency: objectSelector(item, ORDER_ITEM.CURRENCY),
  });
};

const packageItemsMapper = (packageItems) => {
  return packageItems.map((item) => {
    return new PackageItem({
      id: objectSelector(item, $P.PACKAGE_ITEM.ID),
      orderItem: orderItemMapper(
        objectSelector(item, $P.PACKAGE_ITEM.ORDER_ITEM_PATH)
      ),
      state: objectSelector(item, $P.PACKAGE_ITEM.STATE),
      transferDestination: objectSelector(
        item,
        $P.PACKAGE_ITEM.TRANSFER_DESTINATION
      ),
      transferTargetDate: objectSelector(
        item,
        $P.PACKAGE_ITEM.TRANSFER_TARGET_DATE
      ),
      unit_weight: objectSelector(item, 'unit_weight'),
    });
  });
};

export const packageOrderDetailMapper = (item) => {
  const packageOrder = new PackageOrder({
    channelName: objectSelector(item, $P.CHANNEL_NAME),
    commands: objectSelector(item, $P.COMMANDS),
    id: objectSelector(item, $P.ID),
    number: objectSelector(item, $P.NUMBER),
    orderId: objectSelector(item, $P.ORDER_ID),
    orderNumber: objectSelector(item, $P.ORDER_NUMBER),
    orderNotes: objectSelector(item, $P.ORDER_NOTES),
    packageItemSet: packageItemsMapper(
      objectSelector(item, $P.PACKAGE_ITEM_SET_PATH, [])
    ),
    shipment: objectSelector(item, $P.SHIPMENT),
    shipmentCargoName: objectSelector(item, $P.SHIPMENT_CARGO_NAME),
    shipmentAwbNumber: objectSelector(item, $P.SHIPMENT_AWB_NUMBER),
    shippingAddress: shippingAddressMapper(
      objectSelector(item, $P.SHIPPING_ADDRESS_PATH)
    ),
    shippingLabel: objectSelector(item, $P.SHIPPING_LABEL),
    shippingPreviewUrl: objectSelector(item, $P.SHIPPING_PREVIEW_URL),
    state: objectSelector(item, $P.STATE),
    stockLocation: stockLocationMapper(
      objectSelector(item, $P.STOCK_LOCATION_PATH)
    ),
    billingAddress: billingAddressMapper(
      objectSelector(item, $P.BILLING_ADDRESS_PATH)
    ),
    giftBoxNote: objectSelector(item, $P.GIFT_BOX_NOTE),
    deliveryRange: deliveryRangeMapper(
      objectSelector(item, $P.DELIVERY_RANGE_PATH)
    ),
    isClickAndCollect: objectSelector(item, $P.IS_CLICK_AND_COLLECT),
  });
  return packageOrder;
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/packageOrderDetail.js